export default "__VITE_ASSET__$zVhHDVI__"